import React, { useEffect, useRef } from "react";
import { findDOMNode } from "react-dom";
import { useLocation } from "react-router-dom";
import { parseMarkdownEvent } from "@origin-digital/event-dispatcher";
import { Heading, Text, Stack } from "@origin-digital/ods-core";

import { ArticleBodyStyles } from "./ArticleBody.styles";
import { ATTR_NAME, replaceHtml, scrollToAnchor } from "./helper";
import { FdvExit } from "./FdvExit";

interface IArticleBody {
  title: string;
  body: string;
}

export const ArticleBody = ({ body, title }: IArticleBody) => {
  const articleRef = useRef(null);
  const routerLocation = useLocation();

  useEffect(() => {
    scrollToAnchor(routerLocation);
  }, [routerLocation]);

  useEffect(() => {
    const cleanUp: (() => void)[] = [];
    if (articleRef.current && body) {
      // eslint-disable-next-line react/no-find-dom-node
      const dom = findDOMNode(articleRef.current) as Element;
      const elmsList = dom?.querySelectorAll(`a[${ATTR_NAME}]`);
      const elms: Element[] = [].slice.call(elmsList);
      elms.forEach((elm) => {
        const navToMd = elm.getAttribute(ATTR_NAME);
        if (navToMd) {
          const dispatchEvent = parseMarkdownEvent(navToMd, {
            logErrors: true,
          })?.onClick;
          if (dispatchEvent) {
            const cbFn = (e: Event) => {
              e.preventDefault();
              dispatchEvent();
            };
            elm.addEventListener("click", cbFn);
            cleanUp.push(() => elm.removeEventListener("click", cbFn));
          }
        }
      });
    }

    return () => {
      cleanUp.forEach((fn) => fn());
    };
  }, [articleRef, body]); // needs to re-run on new body

  return (
    <>
      <Stack space="xlarge">
        {/*eslint-disable-next-line jsx-a11y/anchor-is-valid*/}
        <a id="heading">
          <Heading component="h1" variant="h3">
            {title}
          </Heading>
        </a>
        <FdvExit path={window.location.pathname} />
      </Stack>
      <Text>
        <ArticleBodyStyles
          ref={articleRef}
          dangerouslySetInnerHTML={{ __html: replaceHtml(body) }}
        />
      </Text>
    </>
  );
};
